module.exports = __webpack_public_path__ + "static/img/17.f0d53b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/17.png
// module id = o0Zm
// module chunks = 2